module.exports = __webpack_public_path__ + "media/images/games/rocket-league/background-69ef812974b653a343b38c37765e599f.jpg";